import React from 'react';
import Form from 'react-bootstrap/Form'
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import jwtClient from '../../JwtClient';

// Depends on values.consigneeAddress
// Delivery to pickup point
export class AddressTMM extends React.Component {
    state = {
        regions: [],
        cities: [],
    };

    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            setFieldValue,
            setFieldError,
            setFieldTouched,
        } = this.props;
        return (
            <div>
                <Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm="2">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Zip</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.zip"
                                        value={values.consigneeAddress.zip}
                                        onChange={(e) => {
                                            handleChange(e);
                                            if (e.target.value.length === 5) {
                                                this.loadRegionsCities(e.target.value)
                                                    .then(() => {
                                                        if (this.state.cities.length === 0 && this.state.regions.length === 0) {
                                                            setFieldValue('consigneeAddress.city', this.state.cities[0], false);
                                                            setFieldValue('consigneeAddress.region', this.state.regions[0], false);
                                                            setFieldTouched('consigneeAddress.zip', true, false);
                                                            setFieldError('consigneeAddress.zip', 'Invalid zip');
                                                        } else {
                                                            setFieldValue('consigneeAddress.city', this.state.cities[0]);
                                                            setFieldValue('consigneeAddress.region', this.state.regions[0]);

                                                        }
                                                    });
                                            }
                                        }}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.zip &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.zip
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.zip
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                            <Col>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Region</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        as="select"
                                        name="consigneeAddress.region"
                                        value={values.consigneeAddress.region}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={this.state.regions.length === 0}
                                    >
                                        {this.state.regions.map((region, index) => {
                                            return <option value={region} key={index}>{region}</option>
                                        })}
                                    </Form.Control>
                                </InputGroup>
                            </Col>
                            <Col>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>City</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        as="select"
                                        name="consigneeAddress.city"
                                        value={values.consigneeAddress.city}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={this.state.cities.length === 0}
                                    >
                                        {this.state.cities.map((region, index) => {
                                            return <option value={region} key={index}>{region}</option>
                                        })}
                                    </Form.Control>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Form.Group>

                    <Form.Group>
                        <Row>
                            <Col sm="6">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Street</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.street"
                                        value={values.consigneeAddress.street}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.street &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.street
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.street
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                            <Col sm="2">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>House</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.house"
                                        value={values.consigneeAddress.house}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.house &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.house
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.house
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                            <Col sm="2">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Corpus</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.corpus"
                                        value={values.consigneeAddress.corpus}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.corpus &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.corpus
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.corpus
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                            <Col sm="2">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Apartment</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="consigneeAddress.apartment"
                                        value={values.consigneeAddress.apartment}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid=
                                            {
                                                touched.consigneeAddress &&
                                                touched.consigneeAddress.apartment &&
                                                errors.consigneeAddress &&
                                                !!errors.consigneeAddress.apartment
                                            }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            errors.consigneeAddress &&
                                            errors.consigneeAddress.apartment
                                        }
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Form.Group>
                </Form.Group>
            </div>
        );
    }

    loadRegionsCities = (zipCode) => {
        const url = '/api/v1/address/tmm/zip/' + zipCode;
        return jwtClient.get(url)
            .then((response) => {
                this.setState({
                    regions: response.data.regions || [],
                    cities: response.data.cities || [],
                });
            })
            .catch((error) => {
                if (error.response) {
                    this.props.showError(error.response.data);
                }
            });
    };
}
